// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

import "trix";
import "@rails/actiontext";

import "preline";

// Prevent the CQC widget from being cached to avoid duplicate rendering
document.addEventListener("turbo:before-cache", function () {
  const script = document.querySelector(
    `script[src="//www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-117260128&data-host=www.cqc.org.uk&type=location"]`,
  );
  if (script) {
    script.remove();
  }
});

// Initialize Preline JS components
document.addEventListener("turbo:load", () => {
  window.HSStaticMethods.autoInit();
});
